module.exports = __webpack_public_path__ + "img/icon-type-audio.c9beebd8.svg";